import { faker } from '@faker-js/faker';

export const document = {
  key: faker.string.uuid(),
  name: faker.system.fileName(),
  refusable: false,
  deadline_at: '2024-03-23T09:43:05-03:00',
  original_url: '/dummy.pdf',
  pdf_url: '/dummy.pdf',
  total_signatures: 1,
  total_signed: 0,
};

export const documents = [document];
